import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import { handleUserResponse } from 'src/features/auth/lib/handleUserResponse';
import axios from 'src/lib/axios';
import { formatResourcePath } from 'src/utils/regex';

import type { LoginResponse, User } from 'src/features/auth/types';
import type { MutationConfig } from 'src/lib/react-query';

const RESOURCE = '/users/login/';

const formSchema = z.object({
    username: z.string(),
    password: z.string().min(1),
});
type FormSchemaValues = z.infer<typeof formSchema>;

type MutationFnType = (data: FormSchemaValues) => Promise<User>;
const mutationFn = (data: FormSchemaValues): Promise<LoginResponse> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

// Attempts to log in the user with the provided username and password and sets the token in the session storage
const useMutationHook = (options: MutationConfig<MutationFnType> = {}) =>
    useMutation({
        mutationFn: async (data: FormSchemaValues) => {
            const response = await mutationFn(data);
            return handleUserResponse(response);
        },
        ...options,
        onSuccess: (user, ...rest) => {
            options?.onSuccess?.(user, ...rest);
        },
    });

export { formSchema as loginFormSchema, useMutationHook as useLogin };
export type { FormSchemaValues as LoginPayload };
